import { getRequest, postRequest, deleteRequest, ApiEnums } from "./DataRequestService";


async function delete_workflows(workflowIds) {
  let apiUrl = ApiEnums.delete_workflows;
  let requestObject = {
    url: apiUrl,
    data: {
      workflow_ids: workflowIds,
    },
  };
  const responseData = await deleteRequest(requestObject);
  if (responseData.status === "success") {
    return responseData;
  }
  console.log(responseData.output || responseData.message);
  return null;
}

async function get_workflows(userId) {
  let apiUrl = ApiEnums.get_workflows;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        user_id: userId,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

//Manage Workflow APIs
// getActPredFcastResults : '/getActPredFcastResults',
// getTopOneModelResults : '/getTopOneModelResults',
// getForecastResults : '/getForecastResults',
// get_sp : '/get_sp',
// getTopThreeModelResults : '/getTopThreeModelResults',

async function getActualPredictedForecastResults(workflow_id) {
  let apiUrl = ApiEnums.getActPredFcastResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

async function getTopOneModelResults(workflow_id) {
  let apiUrl = ApiEnums.getTopOneModelResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

async function getForecastResults(workflow_id) {
  let apiUrl = ApiEnums.getForecastResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

async function getmultipleActPredFcastResults(workflow_id) {
  try {
    let apiUrl = ApiEnums.getmultipleActPredFcastResults;
    let requestObject = {
      url: apiUrl,
      config: {
        params: {
          workflow_id: workflow_id,
        },
      },
    };
    console.log("🔍 getmultipleActPredFcastResults calling API:", apiUrl, "with workflow_id:", workflow_id);
    const responseData = await getRequest(requestObject);
    console.log("🔍 getmultipleActPredFcastResults raw response:", responseData);
    console.log("getmultipleActPredFcastResults response:", { status: responseData.status, hasData: !!responseData.data, hasInnerData: !!responseData.data?.data, hasCities: !!responseData.data?.data?.cities });
    if (responseData.status === "success") {
      const result = responseData.data.data;
      console.log("✅ getmultipleActPredFcastResults returning data:", !!result);
      return result;
    } else if (responseData.status === "failed") {
      console.log("❌ getmultipleActPredFcastResults failed:", responseData.message);
      return null;
    }
    console.log("⚠️ getmultipleActPredFcastResults unexpected status:", responseData.status);
    return null;
  } catch (error) {
    console.error("💥 getmultipleActPredFcastResults exception:", error);
    return null;
  }
}

async function getmultipleModelResults(workflow_id) {
  try {
    let apiUrl = ApiEnums.getmultipleModelResults;
    let requestObject = {
      url: apiUrl,
      config: {
        params: {
          workflow_id: workflow_id,
        },
      },
    };
    console.log("🔍 getmultipleModelResults calling API:", apiUrl, "with workflow_id:", workflow_id);
    const responseData = await getRequest(requestObject);
    console.log("🔍 getmultipleModelResults raw response:", responseData);
    console.log("getmultipleModelResults response:", { status: responseData.status, hasData: !!responseData.data, hasCities: !!responseData.data?.cities });
    if (responseData.status === "success") {
      const result = responseData.data; // SINGLE-wrapped, not double-wrapped like others
      console.log("✅ getmultipleModelResults returning data:", !!result);
      return result;
    } else if (responseData.status === "failed") {
      console.log("❌ getmultipleModelResults failed:", responseData.message);
      return null;
    }
    console.log("⚠️ getmultipleModelResults unexpected status:", responseData.status);
    return null;
  } catch (error) {
    console.error("💥 getmultipleModelResults exception:", error);
    return null;
  }
}

async function getmultipleForecastResults(workflow_id) {
  try {
    let apiUrl = ApiEnums.getmultipleForecastResults;
    let requestObject = {
      url: apiUrl,
      config: {
        params: {
          workflow_id: workflow_id,
        },
      },
    };
    console.log("🔍 getmultipleForecastResults calling API:", apiUrl, "with workflow_id:", workflow_id);
    const responseData = await getRequest(requestObject);
    console.log("🔍 getmultipleForecastResults raw response:", responseData);
    console.log("getmultipleForecastResults response:", { status: responseData.status, hasData: !!responseData.data, hasInnerData: !!responseData.data?.data, hasCities: !!responseData.data?.data?.cities });
    if (responseData.status === "success") {
      const result = responseData.data?.data || responseData.data;
      console.log("✅ getmultipleForecastResults returning data:", !!result);
      return result;
    } else if (responseData.status === "failed") {
      console.log("❌ getmultipleForecastResults failed:", responseData.message);
      return null;
    }
    console.log("⚠️ getmultipleForecastResults unexpected status:", responseData.status);
    return null;
  } catch (error) {
    console.error("💥 getmultipleForecastResults exception:", error);
    return null;
  }
}

async function getContributionBreakdown(workflow_id) {
  const requestObject = {
    url: ApiEnums.getContributionBreakdown,
    config: { params: { workflow_id } },
  };
  const responseData = await getRequest(requestObject);
  return responseData;
}

// Feature Based Forecasting — aggregated city-level actual vs predicted vs forecast.
// Response is double-nested; returns the raw body so the caller can normalize safely.
async function getAggregatedActualPredictedResults(workflow_id) {
  let apiUrl = ApiEnums.getAggregatedActualPredictedResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  return responseData;
}

// Feature Based Forecasting — SKU-to-group mapping selected in Stage 3.
// Returns { status, workflow_id, group_count, total_skus, groups: [{group_name, items:[{sku, description}]}] }
async function getWorkflowFeatureGroups(workflow_id) {
  let apiUrl = ApiEnums.getWorkflowFeatureGroups;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  return responseData;
}

//cityName should be capitallize first letter
async function getSalesPersons(cityName) {
  let apiUrl = ApiEnums.get_sp;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        level5: cityName,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}
async function getWorkkflowCombinations(workflowId) {
  // workflowId = 'bd7c3e51-2e06-42ac-80ae-82157c5f467121'
  let apiUrl = ApiEnums.getWorkflowCombinations;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflowId,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}


export {
  get_workflows,
  delete_workflows,
  getActualPredictedForecastResults,
  getTopOneModelResults,
  getForecastResults,
  getmultipleActPredFcastResults,
  getmultipleModelResults,
  getmultipleForecastResults,
  getAggregatedActualPredictedResults,
  getContributionBreakdown,
  getWorkflowFeatureGroups,
  getSalesPersons,
  getWorkkflowCombinations,
};